<template>
  <popup
    :opened="isOpened"
    @close="$emit('close')"
    :crossed-absolute-component="$isMobile()"
    :dynamic-height="$isMobile()"
  >
    <div class="mx-5 xl:mx-44 2xl:mx-40 my-8 w-auto h-auto">
      <h3 class="mb-10">
        Ajouter une évaluation
      </h3>

      <p class="text-lg text-center text-indigo-600 mb-8">
        Veuillez saisir la période que vous souhaitez évaluer.
      </p>
      <div class="hidden md:flex xxl:ml-6 2xl:ml-0 justify-center">
        <date-picker
          name="date_debut_evaluation"
          :necessary-date="false"
          format="dd/MM/yyyy"
          :value="dateDebut"
          @input="(newValue) => {$emit('changeDateDebut', newValue)}"
          libelle_header="Sélectionner une date de début"
          inline="true"
          class="px-3 inline-block w-full"
        />
        <date-picker
          format="dd/MM/yyyy"
          :necessary-date="false"
          name="date_fin_evaluation"
          :value="dateFin"
          @input="(newValue) => {$emit('changeDateFin', newValue)}"
          libelle_header="Sélectionner une date de fin"
          inline="true"
          class="px-3 inline-block w-full"
        />
      </div>
      <div class="grid md:hidden grid-cols-2 justify-center gap-x-4">
        <date-picker
          name="date_debut_evaluation"
          :necessary-date="false"
          format="dd/MM/yyyy"
          :value="dateDebut"
          @input="(newValue) => {$emit('changeDateDebut', newValue)}"
          libelle_header="Sélectionner une date de début"
          class="col-span-full"
        />
        <date-picker
          format="dd/MM/yyyy"
          :necessary-date="false"
          name="date_fin_evaluation"
          :value="dateFin"
          @input="(newValue) => {$emit('changeDateFin', newValue)}"
          libelle_header="Sélectionner une date de fin"
          class="col-span-full"
        />
      </div>
      <span
        class="flex flex-col items-center justify-center w-full mt-15 lg:mt-5"
      >
        <p
          v-if="evaluationDatesError" 
          class="text-pink-600 mb-5 text-base"
        >
          Veuillez renseigner une date de début et de fin d'évaluation.
        </p>
        <action-button
          border-color="border-transparent"
          text-color="text-white"
          bg-color="bg-pink-600"
          bg-color-square="bg-pink-600"
          icon-color="text-white"
          libelle="CONTINUER"
          :uppercase="true"
          icon="arrow-right_1"
          :right="true"
          @clickAction="createEvaluation"
        />
      </span>
    </div>
  </popup>
</template>

<script>
import Popup from './../Popup.vue';
import ActionButton from './../ActionButton.vue';
import DatePicker from './../Inputs/DatePicker.vue';

export default {
  components:{
    Popup,
    ActionButton,
    DatePicker,
  },

  data(){
    return{
      evaluationDatesError: false,
    };
  },

  methods:{
    createEvaluation(){
      if(this.dateDebut == '' || this.dateFin == ''){
        this.evaluationDatesError = true;
        return;
      }

      this.$emit('createEvaluation');
    }
  },

  props:{
    isOpened:Boolean,
    dateDebut: [Date, String],
    dateFin: [Date, String],
  },


  watch:{
    dateDebut: {
      handler(){
        if(this.evaluationDatesError){
          this.evaluationDatesError = this.dateDebut != '' && this.dateFin != '';
        }
      },
    },
    dateFin: {
      handler(){
        if(this.evaluationDatesError){
          this.evaluationDatesError = this.dateDebut != '' && this.dateFin != '';
        }
      },
    },
  }
};
</script>